import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, CircularProgress } from "@mui/material";
import PublicShell from "./components/PublicShell";
import PassActiveCard from "./components/PassActiveCard";
import { apiErrorMessage, guestApi } from "./publicVehicleApi";
import styles from "./publicvehicle.module.css";

const POLL_INTERVAL_MS = 3000;
const MAX_POLLS = 10;

// Stripe redirects here. The payment module's webhook confirms the payment, so poll until the pass is active.
const GuestVehicleResult = ({ cancelled }) => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [gaveUp, setGaveUp] = useState(false);

  useEffect(() => {
    if (cancelled) return undefined;

    let polls = 0;
    let timer = null;
    let stopped = false;

    const check = async () => {
      try {
        const response = await guestApi.status(token);
        const next = response?.data?.data || null;
        if (stopped) return;
        setData(next);
        if (next?.status !== "AWAITING_PAYMENT") return;
      } catch (err) {
        console.error("[GuestVehicleResult] Failed to check payment status", err);
        if (!stopped) setError(apiErrorMessage(err, "Unable to check your payment status."));
        return;
      }
      polls += 1;
      if (polls >= MAX_POLLS) {
        setGaveUp(true);
        return;
      }
      timer = setTimeout(check, POLL_INTERVAL_MS);
    };

    check();
    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [token, cancelled]);

  if (cancelled) {
    return (<PublicShell title="Payment cancelled">
      <Alert severity="info">Your payment was not completed and you have not been charged.</Alert>
      <div className={styles.actions}><Link to={"/guest-vehicle/" + token} className={styles.primaryButton}>BACK TO PAYMENT</Link></div>
    </PublicShell>);
  }

  const shellProps = { propertyName: data?.property_name, propertyAddress: data?.property_address, propertyPhone: data?.property_phone };
  const active = data?.status === "ACTIVE" || data?.status === "PASS_ENDED";

  return (<PublicShell title={active ? "Parking pass active" : "Confirming your payment"} {...shellProps}>
    {error !== "" && <Alert severity="error">{error}</Alert>}
    {error === "" && !active && !gaveUp && (<div className={styles.center}><CircularProgress size={30} /></div>)}
    {error === "" && !active && gaveUp && (<Alert severity="info">We're still confirming your payment. This can take a few minutes; you'll get a text when your pass is active, or reopen your link to check.</Alert>)}
    {active && <PassActiveCard data={data} />}
  </PublicShell>);
};

export default GuestVehicleResult;

export const GuestVehicleSuccess = () => <GuestVehicleResult cancelled={false} />;
export const GuestVehicleCancelled = () => <GuestVehicleResult cancelled />;
